// 💾 hooks/useAuthProfileGuard.ts
import { useEffect, useState } from "react"
import { onAuthStateChanged, User } from "firebase/auth"
import { doc, getDoc } from "firebase/firestore"
import { auth, db } from "../services/firebase"

export const useAuthProfileGuard = () => {
  const [user, setUser] = useState<User | null>(null)
  const [role, setRole] = useState<"admin" | "client" | null>(null)
  const [status, setStatus] = useState<"Verified" | "notVerified" | null>(null)
  const [authLoading, setAuthLoading] = useState(true)
  const [profileLoading, setProfileLoading] = useState(true)

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      setUser(u)
      setAuthLoading(false)

      if (!u) {
        setProfileLoading(false)
        return
      }

      try {
        const docRef = doc(db, "users", u.uid)
        const snap = await getDoc(docRef)

        if (snap.exists()) {
          const data = snap.data()

          // ✅ Normalize role to lowercase
          const roleValue =
            typeof data.role === "string" ? data.role.toLowerCase() : "client"
          setRole(roleValue === "admin" ? "admin" : "client")

          // ✅ Normalize status
          setStatus(data.status === "Verified" ? "Verified" : "notVerified")
        } else {
          setRole("client")
          setStatus("notVerified")
        }
      } catch (e) {
        console.error("❌ Firestore fetch error", e)
        setRole(null)
        setStatus(null)
      } finally {
        setProfileLoading(false)
      }
    })

    return () => unsub()
  }, [])

  return { user, role, status, authLoading, profileLoading }
}
